import type { TFunction } from 'i18next';

export type IndustryKey =
    | 'adventure'
    | 'agriculture'
    | 'apparel'
    | 'architecture'
    | 'arts'
    | 'arts-and-craft'
    | 'automotive'
    | 'bakery'
    | 'beauty'
    | 'brewery'
    | 'candles'
    | 'care'
    | 'ceramics'
    | 'childcare'
    | 'children'
    | 'climbing'
    | 'collectibles'
    | 'community'
    | 'construction'
    | 'consulting'
    | 'cryotherapy'
    | 'culture'
    | 'design'
    | 'digital'
    | 'doula-services'
    | 'driving-school'
    | 'education'
    | 'entertainment'
    | 'events'
    | 'fashion'
    | 'finance'
    | 'fitness'
    | 'food'
    | 'grocery'
    | 'hair-salon'
    | 'health'
    | 'home-services'
    | 'lifestyle'
    | 'logistics'
    | 'media'
    | 'memorial-services'
    | 'mobile-services'
    | 'mobility'
    | 'music'
    | 'ngo'
    | 'pastry'
    | 'pet-store'
    | 'photography'
    | 'publishing'
    | 'retail'
    | 'sustainability'
    | 'tattoo'
    | 'taxi'
    | 'toys'
    | 'tourism'
    | 'transport'
    | 'wellness'
    | 'yoga';

export const getIndustryLabel = (industryKey: IndustryKey, t: TFunction): string => {
    const industryLabelMap: Record<IndustryKey, string> = {
        adventure: t('Logomaker GenAi Landing Page > Gallery > Industry > adventure.value'),
        agriculture: t('Logomaker GenAi Landing Page > Gallery > Industry > agriculture.value'),
        apparel: t('Logomaker GenAi Landing Page > Gallery > Industry > apparel.value'),
        architecture: t('Logomaker GenAi Landing Page > Gallery > Industry > architecture.value'),
        arts: t('Logomaker GenAi Landing Page > Gallery > Industry > arts.value'),
        'arts-and-craft': t(
            'Logomaker GenAi Landing Page > Gallery > Industry > arts-and-craft.value',
        ),
        automotive: t('Logomaker GenAi Landing Page > Gallery > Industry > automotive.value'),
        bakery: t('Logomaker GenAi Landing Page > Gallery > Industry > bakery.value'),
        beauty: t('Logomaker GenAi Landing Page > Gallery > Industry > beauty.value'),
        brewery: t('Logomaker GenAi Landing Page > Gallery > Industry > brewery.value'),
        candles: t('Logomaker GenAi Landing Page > Gallery > Industry > candles.value'),
        care: t('Logomaker GenAi Landing Page > Gallery > Industry > care.value'),
        ceramics: t('Logomaker GenAi Landing Page > Gallery > Industry > ceramics.value'),
        childcare: t('Logomaker GenAi Landing Page > Gallery > Industry > childcare.value'),
        children: t('Logomaker GenAi Landing Page > Gallery > Industry > children.value'),
        climbing: t('Logomaker GenAi Landing Page > Gallery > Industry > climbing.value'),
        collectibles: t('Logomaker GenAi Landing Page > Gallery > Industry > collectibles.value'),
        community: t('Logomaker GenAi Landing Page > Gallery > Industry > community.value'),
        construction: t('Logomaker GenAi Landing Page > Gallery > Industry > construction.value'),
        consulting: t('Logomaker GenAi Landing Page > Gallery > Industry > consulting.value'),
        cryotherapy: t('Logomaker GenAi Landing Page > Gallery > Industry > cryotherapy.value'),
        culture: t('Logomaker GenAi Landing Page > Gallery > Industry > culture.value'),
        design: t('Logomaker GenAi Landing Page > Gallery > Industry > design.value'),
        digital: t('Logomaker GenAi Landing Page > Gallery > Industry > digital.value'),
        'doula-services': t(
            'Logomaker GenAi Landing Page > Gallery > Industry > doula-services.value',
        ),
        'driving-school': t(
            'Logomaker GenAi Landing Page > Gallery > Industry > driving-school.value',
        ),
        education: t('Logomaker GenAi Landing Page > Gallery > Industry > education.value'),
        entertainment: t('Logomaker GenAi Landing Page > Gallery > Industry > entertainment.value'),
        events: t('Logomaker GenAi Landing Page > Gallery > Industry > events.value'),
        fashion: t('Logomaker GenAi Landing Page > Gallery > Industry > fashion.value'),
        finance: t('Logomaker GenAi Landing Page > Gallery > Industry > finance.value'),
        fitness: t('Logomaker GenAi Landing Page > Gallery > Industry > fitness.value'),
        food: t('Logomaker GenAi Landing Page > Gallery > Industry > food.value'),
        grocery: t('Logomaker GenAi Landing Page > Gallery > Industry > grocery.value'),
        'hair-salon': t('Logomaker GenAi Landing Page > Gallery > Industry > hair-salon.value'),
        health: t('Logomaker GenAi Landing Page > Gallery > Industry > health.value'),
        'home-services': t(
            'Logomaker GenAi Landing Page > Gallery > Industry > home-services.value',
        ),
        lifestyle: t('Logomaker GenAi Landing Page > Gallery > Industry > lifestyle.value'),
        logistics: t('Logomaker GenAi Landing Page > Gallery > Industry > logistics.value'),
        media: t('Logomaker GenAi Landing Page > Gallery > Industry > media.value'),
        'memorial-services': t(
            'Logomaker GenAi Landing Page > Gallery > Industry > memorial-services.value',
        ),
        'mobile-services': t(
            'Logomaker GenAi Landing Page > Gallery > Industry > mobile-services.value',
        ),
        mobility: t('Logomaker GenAi Landing Page > Gallery > Industry > mobility.value'),
        music: t('Logomaker GenAi Landing Page > Gallery > Industry > music.value'),
        ngo: t('Logomaker GenAi Landing Page > Gallery > Industry > ngo.value'),
        pastry: t('Logomaker GenAi Landing Page > Gallery > Industry > pastry.value'),
        photography: t('Logomaker GenAi Landing Page > Gallery > Industry > photography.value'),
        publishing: t('Logomaker GenAi Landing Page > Gallery > Industry > publishing.value'),
        'pet-store': t('Logomaker GenAi Landing Page > Gallery > Industry > pet-store.value'),
        retail: t('Logomaker GenAi Landing Page > Gallery > Industry > retail.value'),
        sustainability: t(
            'Logomaker GenAi Landing Page > Gallery > Industry > sustainability.value',
        ),
        tattoo: t('Logomaker GenAi Landing Page > Gallery > Industry > tattoo.value'),
        taxi: t('Logomaker GenAi Landing Page > Gallery > Industry > taxi.value'),
        toys: t('Logomaker GenAi Landing Page > Gallery > Industry > toys.value'),
        tourism: t('Logomaker GenAi Landing Page > Gallery > Industry > tourism.value'),
        transport: t('Logomaker GenAi Landing Page > Gallery > Industry > transport.value'),
        wellness: t('Logomaker GenAi Landing Page > Gallery > Industry > wellness.value'),
        yoga: t('Logomaker GenAi Landing Page > Gallery > Industry > yoga.value'),
    };

    return industryLabelMap[industryKey] ?? 'General';
};
